const styles = {
  calendarSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    minHeight: 0,
    height: '100%',
  },
  calendarHeaderBar: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  calendarMonthLabel: {
    flexGrow: 1,
    textAlign: 'center',
    fontWeight: 600,
  },
  calendarLegend: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
    flexWrap: 'wrap',
  },
  calendarLegendItem: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
  },
  calendarLegendDot: (bg) => ({
    width: 10,
    height: 10,
    borderRadius: '50%',
    backgroundColor: bg,
    display: 'inline-block',
  }),
  calendarWeekHeader: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
    alignItems: 'center',
    justifyItems: 'center',
    gap: 0.5,
  },
  calendarWeekday: {
    fontSize: '0.75rem',
    color: '#777',
    fontWeight: 600,
    textAlign: 'center',
    width: '100%',
  },
  calendarDaysGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
    gap: 0.5,
    justifyItems: 'center',
    alignItems: 'center',
    minHeight: 0,
    width: '100%',
  },
  calendarPadCell: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  calendarDayCell: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  calendarDayDot: (bg, isSelected, theme, iso, todayIso, dotPx) => ({
    width: dotPx + 4,
    height: dotPx + 4,
    borderRadius: '50%',
    backgroundColor: bg,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: iso > todayIso ? 'default' : 'pointer',
    border: isSelected ? `2px solid ${theme.palette.primary.main}` : '2px solid transparent',
    transition: 'box-shadow 0.15s ease',
    '&:hover': iso > todayIso ? {} : { boxShadow: `0 0 0 1px ${theme.palette.primary.light}` },
  }),
  calendarDayText: (dotPx) => ({
    color: '#fff',
    fontSize: Math.max(11, Math.min(15, Math.floor((dotPx + 2) * 0.48))),
    lineHeight: 1,
    textAlign: 'center',
    userSelect: 'none',
  }),
};

export default styles;
